import type { ValidationErrors } from './validation';

export function removeAllErrorsStartingWithKey(key: string, errors: ValidationErrors): ValidationErrors {
    let cleanedUpErrors = errors;
    errors
        .keySeq()
        .filter((errorKey) => !!errorKey?.startsWith(key) && errorKey !== key)
        .forEach((error) => {
            if (error) {
                cleanedUpErrors = cleanedUpErrors.remove(error);
            }
        });

    return cleanedUpErrors;
}
